import { Navigate } from "react-router-dom";

export function MigrationCreate() {
  return <Navigate to="/migrations" replace />;
}
